import { render, staticRenderFns } from "./ModalReimpressaoDelivery.vue?vue&type=template&id=8454fe00"
import script from "./ModalReimpressaoDelivery.vue?vue&type=script&lang=js"
export * from "./ModalReimpressaoDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports